import { NgxsModuleOptions, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { RegistrationState } from '../../shared/store/registration/registration.state';
import { ApplicationConfig } from './application.config';
import { AuthState } from '../../shared/store/auth/auth.state';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
  executionStrategy: NoopNgxsExecutionStrategy,
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: ['auth.token', 'auth.account'],
};

export const ngxsStates = [
  AuthState,
  ApplicationState,
  CacheDataState,
  RegistrationState,
];
